import React, { useState } from 'react';

const services = [
  {
    num: '/01',
    title: 'Implantes Dentários',
    desc: 'Titânio · Planejamento individual · Reposição de dentes perdidos',
    summary: 'Implantes são pinos biocompatíveis fixados no osso para servir de base a coroas, pontes ou próteses.',
    details: [
      'São indicados para substituir dentes perdidos quando há avaliação favorável do osso, da gengiva e das condições gerais de saúde.',
      'O planejamento considera fatores como quantidade e qualidade óssea, posição do dente, condição periodontal e possibilidade real de restauração.',
      'Nem todo caso é de carga imediata; o tempo do tratamento depende da cicatrização e da estabilidade do implante.',
    ],
  },
  {
    num: '/02',
    title: 'Próteses Fixas & Móveis',
    desc: 'Parcial · Total · Sobre implantes · Reabilitação mastigatória',
    summary: 'Próteses repõem dentes ausentes e ajudam a recuperar mastigação, fala, suporte facial e conforto no dia a dia.',
    details: [
      'Próteses totais substituem todos os dentes; próteses parciais removíveis substituem alguns dentes e usam estruturas de apoio para estabilidade.',
      'Também podem ser planejadas soluções fixas sobre dentes ou implantes, conforme o número de perdas e a condição de suporte.',
      'O desenho ideal depende da mordida, da distribuição dos dentes remanescentes e da adaptação esperada para o paciente.',
    ],
  },
  {
    num: '/03',
    title: 'Ortodontia Invisível',
    desc: 'Alinhadores transparentes · Planejamento digital · Acompanhamento clínico',
    summary: 'Alinhadores transparentes movimentam os dentes gradualmente com pressão controlada e acompanhamento profissional.',
    details: [
      'Os alinhadores são placas finas e transparentes feitas sob medida para serem trocadas em sequência ao longo do tratamento.',
      'Em geral, precisam ser usados por cerca de 22 horas por dia para entregar a movimentação planejada.',
      'A indicação depende do tipo de desalinhamento, da previsibilidade biomecânica do caso e da disciplina de uso.',
    ],
  },
  {
    num: '/04',
    title: 'Lentes de Contato Dentais',
    desc: 'Porcelana · Ajuste de forma e cor · Preservação de esmalte',
    summary: 'Lentes e facetas finas de porcelana são usadas para corrigir forma, cor, pequenas fraturas e espaços entre dentes.',
    details: [
      'Costumam ser indicadas quando os dentes estão relativamente íntegros, mas apresentam alteração estética de formato, cor ou borda.',
      'São peças delgadas cimentadas sobre a face externa do dente, geralmente com preparo limitado ao esmalte.',
      'A avaliação precisa verificar mordida, hábitos como apertamento e a real necessidade de desgaste antes de indicar o procedimento.',
    ],
  },
  {
    num: '/05',
    title: 'Clareamento & Estética',
    desc: 'Consultório · Caseiro supervisionado · Avaliação prévia',
    summary: 'O clareamento dental clareia dentes naturais com gel clareador, em consultório ou com moldeiras supervisionadas.',
    details: [
      'É mais seguro quando indicado e acompanhado por dentista, porque a avaliação define concentração, técnica e tempo de uso.',
      'O resultado não altera a cor de coroas, facetas, próteses ou implantes; por isso, o planejamento estético precisa considerar restaurações já existentes.',
      'Antes do clareamento, é importante avaliar cárie, sensibilidade, infiltrações e saúde gengival.',
    ],
  },
  {
    num: '/06',
    title: 'Canal, Obturação & Profilaxia',
    desc: 'Endodontia · Restaurações · Limpeza profissional',
    summary: 'Aqui entram tratamentos para salvar dentes com polpa inflamada ou infectada, restaurar cavidades e remover placa endurecida.',
    details: [
      'O tratamento de canal remove a polpa inflamada ou infectada, limpa e desinfeta o interior do dente e depois sela esse espaço.',
      'A obturação é usada para reparar cavidades: o dentista remove a cárie e preenche a área com material restaurador.',
      'A profilaxia e a limpeza profissional ajudam no controle de placa e tártaro; quando a placa endurece, sua remoção passa a depender do dentista ou do higienista.',
    ],
  },
];

const Services = () => {
  const [openItem, setOpenItem] = useState(services[0].num);

  return (
    <>
      <div className="divider" id="servicos">
        <span><span className="dot"></span> 02 / Serviços</span>
        <span>O que fazemos</span>
      </div>

      <section className="servicos">
        <div className="servicos-head">
          <h2 className="display">
            Tratamentos feitos com <em>tempo</em> e técnica.
          </h2>
          <p className="aside">
            Uma leitura mais clara do que oferecemos, com indicação, objetivo e
            limites de cada tratamento.
          </p>
        </div>

        <div className="servicos-list service-accordion">
          {services.map(service => {
            const isOpen = openItem === service.num;

            return (
              <article
                key={service.num}
                className={`service-item${isOpen ? ' open' : ''}`}
              >
                <button
                  type="button"
                  className="service-trigger"
                  onClick={() => setOpenItem(isOpen ? '' : service.num)}
                  aria-expanded={isOpen}
                >
                  <span className="s-num">{service.num}</span>
                  <span className="service-copy">
                    <span className="s-title">{service.title}</span>
                    <span className="s-desc">{service.desc}</span>
                  </span>
                  <span className="service-plus" aria-hidden="true"></span>
                </button>

                <div className="service-panel">
                  <div className="service-panel-inner">
                    <p className="service-summary">{service.summary}</p>
                    <ul className="service-points">
                      {service.details.map(point => (
                        <li key={point}>{point}</li>
                      ))}
                    </ul>
                    <a
                      href="#marcar"
                      className="service-link"
                      onClick={e => {
                        e.preventDefault();
                        document.querySelector('#marcar')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                    >
                      Agendar avaliação →
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Services;
